import Vue from "vue";
import Router from "vue-router";
import { isLoggedIn } from "../utils/auth";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("../pages/Login.vue"),
      meta: {
        publicPage: true,
      },
    },
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "home",
      component: () => import("../pages/Home.vue"),
    },
    {
      path: "/todo/:type",
      name: "todo-list",
      component: () => import("../pages/TodoList.vue"),
    },
    {
      path: "/workorder/:id",
      name: "workorder-detail",
      component: () => import("../pages/WorkorderDetail.vue"),
    },
    {
      path: "/workorder-create",
      name: "workorder-create",
      component: () => import("../pages/WorkorderCreate.vue"),
    },
    {
      path: "/gov-map",
      name: "gov-map",
      component: () => import("../pages/GovMap.vue"),
    },
    {
      path: "/lawcase-create",
      name: "lawcase-create",
      component: () => import("../pages/LawcaseCreate.vue"),
    },
    {
      path: "/construction-beian-create",
      name: "construction-beian-create",
      component: () => import("../pages/ConstructionBeianCreate.vue"),
    },
    {
      path: "/supervise/:module",
      name: "supervise-list",
      component: () => import("../pages/SuperviseList.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.publicPage) {
    if (to.path === "/login" && isLoggedIn()) {
      next("/home");
      return;
    }
    next();
    return;
  }

  if (!isLoggedIn()) {
    next("/login");
    return;
  }

  next();
});

export default router;
